// extracted by mini-css-extract-plugin
module.exports = {"container":"adminList_container__3qchr","disableMargin":"adminList_disableMargin__2URM_","list":"adminList_list__cOWZx"};